import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api';
import { UserAPI } from '../../../../shared/types/api';

// Re-export types for convenience
export type Payment = UserAPI.Payment;

// Get payment history
export function usePaymentHistory() {
  return useQuery({
    queryKey: ['payment', 'history'],
    queryFn: () => api.get<UserAPI.PaymentHistoryData>('/user/payment/payment-history'),
  });
}

// Get payment options with optional coupon code
export function useGetPaymentOptions() {
  return useMutation({
    mutationFn: async (data: UserAPI.GetPaymentOptionsRequest): Promise<UserAPI.GetPaymentOptionsResponse> => {
      return api.post('/user/payment/payment-options', data);
    },
  });
}

// Cancel subscription at period end
export function useCancelSubscription() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: UserAPI.CancelSubscriptionRequest): Promise<UserAPI.CancelSubscriptionResponse> => {
      return api.post('/user/payment/cancel-subscription', data);
    },
    onSuccess: () => {
      // Invalidate profile query to refetch updated entitlements
      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: ['profile'] });
      }, 1000);
    },
  });
}

